module.exports = __webpack_public_path__ + "static/media/15-4.1c7e2a6d.mp3";